import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import HierarchyVertical from '../../../commonComponents/icons/HierarchyVertical';
import HierarchyHorizontal from '../../../commonComponents/icons/HierarchyHorizontal';
import translate from '../../../commonComponents/translate';
import TextFilter from '../../../commonComponents/lists/filters/TextFilter';
import { debounce } from '../../../services/utilityFunctions';
import SelectDropdown from '../../../commonComponents/forms/SelectDropdown';
import AsyncDateRange from '../../../commonComponents/forms/inputs/AsyncDateRange';

export const ORIENTATION = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
};

function TreeHeaderBarFilters(props) {
  const {
    t,
    onDateChange,
    onFiltersChange,
    onOrientationChange,
    filters,
    orientation,
    onClearFilters,
    section,
    onOpenModal,
    totalAvailableUsers,
    showBinaryPlacement,
    binaryPlaceUserBehavioursItems,
    binaryPlaceUserBehaviour,
    onUpdateBinaryPlacement,
    isUpdateUserLoading,
  } = props;

  const handleUpdateBinaryPlacement = useCallback(value => {
    onUpdateBinaryPlacement({
      directSelling: { binaryPlaceUserBehaviour: value },
    });
  }, []);

  return (
    <div>
      <div className="row team-structure-filters">
        <div className="col-lg-3 col-12">
          <TextFilter
            id="search"
            onChange={debounce(onFiltersChange('search'), 300)}
            placeholder={t('search.user')}
            value={filters.search}
          />
        </div>
        <div className="col-lg-4 col-12">
          <AsyncDateRange
            id="filterDate"
            startDate={filters.startDate}
            endDate={filters.endDate}
            placeholder={t('commissions.filter_date_placeholder')}
            onChange={({ startDate, endDate, rangeType }) => {
              onDateChange(startDate, endDate, rangeType);
            }}
            opens="left"
            onClear={onClearFilters}
          />
        </div>
        {section === 'sponsor' && (
          <div className="col-lg-5 col-12">
            <div className="orientation-btns">
              <button
                type="button"
                className={`orientation vertical ${
                  orientation === ORIENTATION.VERTICAL ? 'active' : ''
                }`}
                onClick={() => onOrientationChange(ORIENTATION.VERTICAL)}
              >
                <HierarchyVertical />
                {t('orientation.vertical')}
              </button>
              <button
                type="button"
                className={`orientation horizontal ${
                  orientation === ORIENTATION.HORIZONTAL ? 'active' : ''
                }`}
                onClick={() => onOrientationChange(ORIENTATION.HORIZONTAL)}
              >
                {t('orientation.horizontal')}
                <HierarchyHorizontal />
              </button>
            </div>
          </div>
        )}
        {section === 'binary' && (
          <div className="col-lg-5 col-12 orientation-btns binary-container-options">
            {showBinaryPlacement ? (
              <SelectDropdown
                id="binaryPlacement2"
                items={binaryPlaceUserBehavioursItems}
                value={binaryPlaceUserBehaviour}
                onChange={handleUpdateBinaryPlacement}
                searchable
                allowClear={false}
                disabled={isUpdateUserLoading}
                title="Placement settings"
              />
            ) : null}
            <button
              type="button"
              onClick={onOpenModal}
              disabled={!totalAvailableUsers}
              className={`btn btn-info available-users-button ${
                !totalAvailableUsers && 'no-users-button'
              }`}
            >
              {`${t('see.users.on.hold')}${
                !totalAvailableUsers ? '' : `(${totalAvailableUsers})`
              }`}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

TreeHeaderBarFilters.propTypes = {
  t: PropTypes.func.isRequired,
  onDateChange: PropTypes.func.isRequired,
  onFiltersChange: PropTypes.func.isRequired,
  onOrientationChange: PropTypes.func,
  onClearFilters: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    startDate: PropTypes.number,
    endDate: PropTypes.number,
    search: PropTypes.string,
  }).isRequired,
  orientation: PropTypes.string.isRequired,
  section: PropTypes.string.isRequired,
  onOpenModal: PropTypes.func.isRequired,
  totalAvailableUsers: PropTypes.number.isRequired,
  showBinaryPlacement: PropTypes.bool,
  binaryPlaceUserBehavioursItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      text: PropTypes.string,
    }),
  ),
  binaryPlaceUserBehaviour: PropTypes.string,
  onUpdateBinaryPlacement: PropTypes.func,
  isUpdateUserLoading: PropTypes.bool,
};

TreeHeaderBarFilters.defaultProps = {
  onOrientationChange: null,
  showBinaryPlacement: false,
  binaryPlaceUserBehavioursItems: [],
  binaryPlaceUserBehaviour: '',
  onUpdateBinaryPlacement: () => {},
  isUpdateUserLoading: false,
};

export default translate(TreeHeaderBarFilters);
